exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-box[data-v-60a3496a] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.image-box img[data-v-60a3496a] {\n  width: 100%;\n  height: 100%;\n  vertical-align: middle;\n  object-fit: cover;\n  object-position: center;\n  font-size: 0px;\n}\n.icon-box.default-size[data-v-60a3496a] {\n  width: 100% !important;\n}\n", ""]);

// exports
